module.exports = require("miniprogram-render");